import { DisputeButton_getInstance2kmp95ogq1c02 as DisputeButton_getInstance } from '../theming/formThemes.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from './GenericConfirmationDialog.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../theming/buttons.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function confirmLockProject(_this__u8e3s4, onLock) {
  var tmp = DisputeButton_getInstance();
  confirmationDialog(_this__u8e3s4, 'Lock Project?', "Locking ends negotiations and freezes all funds in escrow. After locking, parties can still reach agreement and unlock, or proceed to formal dispute resolution. Funds can only be released following joint agreement, an independent decision, or as otherwise required by Stoze's Terms of Service (stoze.io/platform-terms).\n\nStoze holds funds as a neutral escrow agent and does not determine disbursement.", 'Continue', VOID, tmp, VOID, false, VOID, VOID, confirmLockProject$slambda_0(onLock));
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.qi8_1.pi8_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var ConfirmLockDialog$render$slambdaClass;
function ConfirmLockDialog$render$slambda() {
  if (ConfirmLockDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ConfirmLockDialog$render$slambdaClass = $;
  }
  return ConfirmLockDialog$render$slambdaClass;
}
function ConfirmLockDialog$render$slambda_0() {
  var i = new (ConfirmLockDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var ConfirmLockDialog$render$slambdaClass_0;
function ConfirmLockDialog$render$slambda_1() {
  if (ConfirmLockDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.qi8_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ConfirmLockDialog$render$slambdaClass_0 = $;
  }
  return ConfirmLockDialog$render$slambdaClass_0;
}
function ConfirmLockDialog$render$slambda_2(this$0) {
  var i = new (ConfirmLockDialog$render$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ConfirmLockDialog$render$slambdaClass_1;
function ConfirmLockDialog$render$slambda_3() {
  if (ConfirmLockDialog$render$slambdaClass_1 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ConfirmLockDialog$render$slambdaClass_1 = $;
  }
  return ConfirmLockDialog$render$slambdaClass_1;
}
function ConfirmLockDialog$render$slambda_4() {
  var i = new (ConfirmLockDialog$render$slambda_3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ConfirmLockDialogClass;
function ConfirmLockDialog() {
  if (ConfirmLockDialogClass === VOID) {
    class $ {
      constructor(onLock) {
        this.pi8_1 = onLock;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(ConfirmLockDialog$render$slambda_0());
        var tmp = view.ibb(get_centered(view), view.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        title(view_0, 'Confirm Lock');
        body(view_0, 'To confirm you want to lock this project and end negotiations, type the word "LOCK" below.');
        var input = Signal().fak('');
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc(), 0.5);
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_0.fbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_0 = view_0.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (TextInput())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_2.tb5_1.zb3_1.ib7_1.placeholder = 'LOCK';
        view_2.xah(view_2.gcn_1, input);
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp_0, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Space())(view_0.pc(), 0.5);
        var tmp0_elvis_lhs_3 = view_0.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.ebb(p_3, view_3);
        view_0.fbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.ebb(p_4, view_4);
        view_4.xbm(false);
        var tmp_1 = view_4.ibb(get_centered(view_4), view_4.hbb(DisputeButton_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = Button$_get_enabled_$ref_61t7nx(view_5);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, Button$_set_enabled_$ref_o8kynz(view_5));
        reactiveScope(view_5, ($this$reactiveScope) => {
          // Inline function 'kotlin.text.trim' call
          var this_1 = $this$reactiveScope.baj(input);
          var tmp$ret$13 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE())) === 'LOCK';
          this_0.set(tmp$ret$13);
          return Unit_instance;
        });
        specCenteredText(view_5, 'Lock Project');
        onClick(view_5, VOID, VOID, ConfirmLockDialog$render$slambda_2(this));
        view_4.fbb(p_5, view_5);
        view_4.jbb(tmp_1, view_5);
        var tmp_4 = view_4.ibb(get_centered(view_4), get_textButton(view_4));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.ebb(p_6, view_6);
        specCenteredText(view_6, 'Go Back');
        onClick(view_6, VOID, VOID, ConfirmLockDialog$render$slambda_4());
        view_4.fbb(p_6, view_6);
        view_4.jbb(tmp_4, view_6);
        view_0.fbb(p_4, view_4);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'ConfirmLockDialog', VOID, VOID, [Page()]);
    ConfirmLockDialogClass = $;
  }
  return ConfirmLockDialogClass;
}
var confirmLockProject$slambdaClass;
function confirmLockProject$slambda() {
  if (confirmLockProject$slambdaClass === VOID) {
    class $ {
      constructor($onLock) {
        this.ri8_1 = $onLock;
      }
      sao($completion) {
        get_dialogStack().xgd(new (ConfirmLockDialog())(this.ri8_1));
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    confirmLockProject$slambdaClass = $;
  }
  return confirmLockProject$slambdaClass;
}
function confirmLockProject$slambda_0($onLock) {
  var i = new (confirmLockProject$slambda())($onLock);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  confirmLockProject as confirmLockProject3pubn8irheo5y,
};
//endregion

//# sourceMappingURL=ConfirmLockProjectDialog.mjs.map
